export var statusMapper = function (data) {
    var result = {};
    if (data) {
        result = {
            authorize: data.holdings.authorize,
            dpId: data.holdings.dpId,
            email: data.holdings.email,
            end: data.holdings.end,
            max: data.holdings.max,
            mobile: data.holdings.mob,
            registeredEmail: data.holdings.regEmail,
            registeredMob: data.holdings.regMob,
            setDate: data.holdings.setDt,
            setId: data.holdings.setId,
            setType: data.holdings.settType,
            start: data.holdings.start,
            auth: mantainAuthAndUnauthData(data.holdings.auth),
            unauth: mantainAuthAndUnauthData(data.holdings.unauth),
            status: data === null || data === void 0 ? void 0 : data.status,
        };
    }
    return result;
};
var mantainAuthAndUnauthData = function (item) {
    return {
        msg: item.msg,
        list: item.lst.map(function (data) {
            return {
                bseSym: data.bseSym,
                isin: data.isin,
                nseSymbol: data.nseSym,
                quantity: data.qty,
                ref: data.ref,
                select: data.select,
                setDate: data.setDt,
                setId: data.setId,
                setType: data.settType,
                status: data.sts,
                symbol: data.sym,
                symbolName: data.symNm,
            };
        }),
    };
};
